enum CheckoutStep {
  PREVIEW = 'PREVIEW',
  CONFIRM = 'CONFIRM'
}

export default CheckoutStep
